import { z } from "zod";
import { zArr, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export const DbPlant = zObj({
    id: zNum(),
    name: zStr(),
    device: zStr(),
    companyName: zOptional(zStr()),
});
export const DbPlants = zArr(DbPlant);
export const DbDevice = zObj({
    id: zNum(),
    name: zStr(),
    plantName: zStr(),
});
export const DbDevices = zArr(DbDevice);
export const GetAssetsOfPlantArg = zObj({
    name: zStr(),
});
export const LogEntry = zObj({
    id: zNum(),
    timestamp: zStr(),
    contents: zStr(),
});
export const LogEntryCollection = zObj({
    source: zStr(),
    entries: zArr(LogEntry),
});
export const StateAlias = zObj({
    value: zNum(),
    label: zStr(),
});
export const StateAliasesOfUnit = zObj({
    unit: zStr(),
    unitId: zNum(),
    states: zArr(StateAlias),
});
export const StateAliasesOfUnits = zArr(StateAliasesOfUnit);
export const GetDofDataSenderSensorsArgs = z.object({
    plantId: z.number(),
});
export const DofDataSenderSensors = z.object({
    sensorIds: z.array(z.number()),
});
//# sourceMappingURL=db.js.map